if (!customElements.get('add-to-cart-button')) {
  customElements.define('add-to-cart-button', class addToCartButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.notifyMeComponent = this.querySelector('component-notify-me');
      this.presaleModel = this.querySelector('component-presale-model');
      this.badgeWrapper = this.querySelector('.badge-wrapper ');
      this.ajaxAPI = new API('ajax');
      this.cart = document.querySelector('cart-drawer');
      this.loyalityProgramProductPoints = this.dataset.loyalityProgramProductPoints ? Number(this.dataset.loyalityProgramProductPoints) : null;
      this.productId = this.dataset.productId;
      this.position = this.dataset.position;
    }

    updateVariant(variantId, variantStatus) {
      if(this.loyalityProgramProductPoints && !app.customer) return;
      this.dataset.variantId = variantId;
      this.dataset.status = variantStatus;
      this.dataset.variantSelected = true;
      this.renderButton();
    }

    showVariantNotSelectedMessage() {
      const chooseSizeNotification = document.querySelector('.component-choose-size');
      chooseSizeNotification && chooseSizeNotification.classList.remove('hidden');
    }

    renderButton () {
      switch(this.dataset.status) {
        case 'launching': {
          this.badgeWrapper && this.badgeWrapper.classList.add('hide-buttons-budge');
          this.button.textContent = this.dataset.launching;
          break;
        }
        case 'soldout': {
          this.badgeWrapper && this.badgeWrapper.classList.add('hide-buttons-budge');
          this.button.dataset.variantId = this.dataset.variantId;
          this.button.textContent = 'Notify me when in stock';
          break;
        }
        case 'presale': {
          this.badgeWrapper && this.badgeWrapper.classList.remove('hide-buttons-budge');
          this.button.textContent = this.loyalityProgramProductPoints ? 'Pre order - Buy with points' : 'Pre order';
          break;
        }
        default: {
          this.badgeWrapper && this.badgeWrapper.classList.add('hide-buttons-budge');
          this.button.textContent = this.loyalityProgramProductPoints ? 'Buy with points' : 'Add to cart';
        }
      }
    }

    getProperties(productRewardPoints) {
      let properties = {}
      if(this.dataset.status === 'presale') {
        properties = {
          ...properties,
          'Order Type': 'This product is on Pre Order'
        }
      }

      if(productRewardPoints) {
        properties = {
          ...properties,
          rewardPoints: productRewardPoints
        }
      }
       
      return properties;
    }

    async addToCart() {
      this.button.disabled = true;
      let productRewardPoints;
      let productRewardPointResponseData;
      let isEnoughPoints = false;

      if(app.customer) {
        productRewardPointResponseData = await app.customer.getProductRewardPoints(this.productId);
        if(productRewardPointResponseData.is_reward_product) {
          productRewardPoints = productRewardPointResponseData.reward_product_configuration.points_price;
          isEnoughPoints = await app.customer.isEnoughPoints(productRewardPoints);

          if(!isEnoughPoints) {
            productRewardPoints = null;
            if(this.position === 'product_page') {
              this.button.disabled = false;
              const rewardPopup = document.querySelector('component-reward-popup');
              return rewardPopup.open();
            }
          } else {
            isEnoughPoints && app.customer.addCustomerUsedRewardPoints(productRewardPoints);
          }
        }
      }

      if(this.dataset.status === 'presale') {
        this.presaleModel.toggleNotifyMePopUp('open', this.dataset.variantId);
      }

      const properties = this.getProperties(productRewardPoints);

      const body = {
        quantity: 1,
        id: this.dataset.variantId,
        properties,
        sections: this.cart.getSectionsToRender().map((section) => section.id),
      }
      
      const data = await this.ajaxAPI.cartAdd(body);
      // render and open the cart drawer
      await this.cart.renderContents(data);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      if (cartDrawerWrapper) cartDrawerWrapper.classList.remove('is-empty');
      this.button.disabled = false;
    }

    connectedCallback() {
      this.addEventListeners();
    }

    async onButtonClickHandler(event) {
      if (!this.dataset.variantSelected) {
        this.showVariantNotSelectedMessage();
        return;
      }
      if (this.dataset.status === 'addtocart' || this.dataset.status === 'presale') {
        const isFirstAddToCartPopupOpened = JSON.parse(sessionStorage.getItem('isFirstAddToCartPopupOpened')) || false;
        !isFirstAddToCartPopupOpened ? this.firstAddtoCartPopupOpen() : null;
        await this.addToCart();
      }
      if (this.dataset.status === 'soldout') {
        this.notifyMeComponent.toggleNotifyMePopUp('open', this.dataset.variantId);
      }
    }

    firstAddtoCartPopupOpen() {
      const firstAddToCartPopup = document.querySelector('first-addtocart-popup');
      firstAddToCartPopup && firstAddToCartPopup.open();
    }

    addEventListeners() {
      !this.dataset.disabled && this.button.addEventListener('click', this.onButtonClickHandler.bind(this));
    }
  });
};
